<template>
  <section id="header" class="desktop-header fixed-top">
    <div class="bg-purple">
      <b-navbar class="main-navbar container" toggleable="lg" type="dark">
        <b-navbar-brand>
          <a :href="revampWebURL" data-cta="siteheader_logo">
            <img src="@/assets/logo.svg" alt="Paxel" />
          </a>
        </b-navbar-brand>
        <b-navbar-toggle target="main-navbar-collapse"
          data-cta="siteheader_menu_toggle"></b-navbar-toggle>
        <b-collapse id="main-navbar-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :href="`${revampWebURL}/our-service`" data-cta="siteheader_layanan_kami">
              {{ $t('our_services') }}
            </b-nav-item>
            <b-nav-item :href="`${revampWebURL}/news-and-promos`"
              data-cta="siteheader_berita_promo">
              {{ $t('news_and_promos') }}
            </b-nav-item>
            <b-nav-item :href="`${revampWebURL}/antarkan-kebaikan`"
              data-cta="siteheader_antarkan_kebaikan">
              #AntarkanKebaikan
            </b-nav-item>
            <b-nav-item-dropdown
              menu-class="p-0 minw-none bg-purple border-none shadow animate slide-in"
              data-cta="siteheader_kemitraan">
                <template slot="text">
                    {{ $t('partnership') }}
                </template>
                <b-dropdown-item :href="`${revampWebURL}/partnership`"
                  data-cta="siteheader_kemitraan_tentang">
                  {{ $t('about_partnership') }}
                </b-dropdown-item>
                <b-dropdown-item :href="corporateURL" data-cta="siteheader_kemitraan_corporate">
                  Corporate
                </b-dropdown-item>
                <b-dropdown-item :href="`${revampWebBaseURL}/mitrapaxel`"
                  data-cta="siteheader_kemitraan_mitra_paxelco">
                  Mitra PaxelCo
                </b-dropdown-item>
                <b-dropdown-item :href="paxelBigURL" data-cta="siteheader_kemitraan_paxelbig">
                  PaxelBig
                </b-dropdown-item>
                <b-dropdown-item to="/#paxelbox"
                  data-cta="siteheader_kemitraan_paxelbox">PaxelBox</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown
              menu-class="p-0 minw-none bg-purple border-none shadow animate slide-in"
              data-cta="siteheader_bahasa">
                <template slot="button-content">
                    <flag :iso="selectedFlag" v-bind:squared=false />
                </template>
                <b-dropdown-item
                  v-for="entry in availableLanguages"
                  :key="entry.title"
                  :data-cta="'siteheader_bahasa_' + entry.language.toLowerCase()"
                  @click="changeLocale(entry.language)">
                    <flag :iso="entry.flag" v-bind:squared=false />
                    <span style="fontSize: 14px;verticalAlign:top;">{{ entry.title }}</span>
                </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div class="clearfix"></div>
    <div class="bg-dark-purple">
      <b-navbar class="sub-navbar container" toggleable="lg" type="dark">
        <b-navbar-brand></b-navbar-brand>
        <b-navbar-toggle target="sub-navbar-collapse"
          data-cta="siteheader_subnav_toggle"></b-navbar-toggle>
        <b-collapse id="sub-navbar-collapse" v-b-scrollspy="scrollConfig" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :to="{name: 'index', hash: '#paxelbox'}"
              data-cta="siteheader_subnav_paxelbox" @click="scrollToAnchor" exact>
              PaxelBox
            </b-nav-item>
            <b-nav-item :to="{name: 'index', hash: '#services'}"
              data-cta="siteheader_subnav_layanan" @click="scrollToAnchor" exact>
              {{ $t('services') }}
            </b-nav-item>
            <b-nav-item :to="{name: 'index', hash: '#location'}"
              data-cta="siteheader_subnav_lokasi" @click="scrollToAnchor" exact>
              {{ $t('location') }}
            </b-nav-item>
            <b-nav-item :to="{name: 'index', hash: '#contact'}"
              data-cta="siteheader_subnav_kontak" @click="scrollToAnchor" exact>
              {{ $t('contact') }}
            </b-nav-item>
            <b-nav-item :href="`${revampWebURL}/help-and-support`" data-cta="siteheader_subnav_faq">
              FAQ
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </section>
</template>

<script>
import i18n from '@/plugins/i18n';
import LocalStorage from '@/services/localstorage';

export default {
  name: 'DesktopHeader',
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      this.selectedFlag = locale === 'id' ? 'id' : 'gb';
      this.$store.dispatch('changeLanguage', locale);
      LocalStorage.setLanguage(locale);
    },
    scrollToAnchor() {
      this.$root.scrollToAnchor(this.$route.hash);
    },
  },
  computed: {
    availableLanguages() {
      return this.languages.slice(0).sort((a) => (a.language === i18n.locale ? -1 : 1));
    },
    revampWebURL() {
      return `${this.revampWebBaseURL}/${i18n.locale}`;
    },
    revampFAQParams() {
      return `?category=${i18n.locale === 'id' ? this.revampWebFAQParamId : this.revampWebFAQParamEn}`;
    },
  },
  data() {
    return {
      revampWebBaseURL: process.env.VUE_APP_REVAMP_WEB,
      revampWebFAQParamEn: process.env.VUE_APP_FAQ_PARAM_EN,
      revampWebFAQParamId: process.env.VUE_APP_FAQ_PARAM_ID,
      paxelBigURL: process.env.VUE_APP_PAXEL_BIG_WEB,
      corporateURL: process.env.VUE_APP_CORPORATE_WEB,
      selectedFlag: i18n.locale === 'id' ? 'id' : 'gb',
      scrollConfig: {
        element: 'body',
        offset: 270,
        method: 'auto',
        throttle: 3000,
      },
      languages: [
        { flag: 'gb', language: 'en', title: 'English' },
        { flag: 'id', language: 'id', title: 'Bahasa' },
      ],
    };
  },
};
</script>

<style scoped>
.main-navbar {
  font-family: 'GothamMedium';
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 22px 15px 18px 15px;
  height: 100%;
}
.sub-navbar {
  font-family: 'GothamMedium';
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 12px 15px 12px 15px;
}
.sub-navbar-colapse {
  margin-right: 70px;
}
.flag-icon {
  font-size: 16px;
  width: 24px;
  margin-right: 5px;
}
</style>
<style>
.desktop-header .dropdown-menu {
  top: 31px;
}
.desktop-header .dropdown-item {
  /* padding: 6px 20px 6px 20px; */
  padding: 7px 20px 7px 20px;
}
.desktop-header .dropdown-toggle::after {
  vertical-align: .125em;
}
</style>
